/* Native cart drawer: self-controlled open/close + Monster-style interactions.
   ONE render per action. Free gift auto-managed (exactly one line, qty 1). Bar
   animates from its current fill to the new one (no reset-to-zero on every update). */
(function () {
  if (window.__fpCartLoaded) return;   // snippet/script can be injected more than once — init only once
  window.__fpCartLoaded = true;
  /* variant ids come from Liquid (window.__fpIds, set in snippets/cart-drawer.liquid) so a
     re-created product doesn't silently break the cart; hardcoded values are the fallback */
  var IDS = window.__fpIds || {};
  var GIFT_VARIANT = IDS.gift || 48469326102753; // free gift (The Responsible Gun Owners Emergency Preparedness Guide)
  var HOLSTER_VARIANT = IDS.holster || 48461273497825; // TACFENDER Universal Holster — 3+1 BXGY target
  /* 3+1 deal: for P PAID holster units the cart must hold P + floor(P/3) TOTAL units —
     the extra ones are the BXGY $0 freebies (3 paid -> 4 total, 6 paid -> 8 total). */
  function holsterTotalFor(paid) { return paid + Math.floor(paid / 3); }
  function drawer() { return document.querySelector('cart-drawer'); }

  function lockScroll(on) {
    document.body.style.overflow = on ? 'hidden' : '';
    document.body.classList.toggle('overflow-hidden', !!on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }

  /* progress bar: tween from the previously shown fill to the new target */
  function animateBar() {
    var span = document.querySelector('#CartDrawer .fpc-bar span');
    if (!span) return;
    var target = parseFloat(span.getAttribute('data-pct'));
    if (isNaN(target)) return;
    var from = (animateBar.last == null) ? 0 : animateBar.last;
    span.style.transition = 'none';
    span.style.width = from + '%';
    void span.offsetWidth;            // commit "from" with no animation
    span.style.transition = '';       // restore the CSS transition
    requestAnimationFrame(function () { span.style.width = target + '%'; });
    animateBar.last = target;
  }

  /* keep exactly one gift line (qty 1) while a paid product is in the cart; done(changed) */
  function manageGift(done) {
    if (manageGift.__busy || manageGift.__disabled) { done && done(false); return; }
    manageGift.__busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var paid = 0, giftQty = 0, giftCharged = false;
      c.items.forEach(function (i) { if (i.id === GIFT_VARIANT) { giftQty += i.quantity; if (i.final_line_price > 0) giftCharged = true; } else if (i.price > 0) paid += i.quantity; });
      var want = paid >= 1 ? 1 : 0;
      /* GUARD: the gift is only free because a store discount prices it at $0. If that
         discount is missing the customer would be CHARGED for it — remove it and stop. */
      if (giftCharged) { manageGift.__disabled = true; want = 0; }
      function fin(ch) { manageGift.__busy = false; done && done(ch); }
      if (giftQty !== want) {
        var body = { updates: {} }; body.updates[GIFT_VARIANT] = want;
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function () { fin(true); }).catch(function () { fin(false); });
      } else { fin(false); }
    }).catch(function () { manageGift.__busy = false; done && done(false); });
  }

  function busy(on) { var inner = document.getElementById('CartDrawer'); if (inner) inner.classList.toggle('is-busy', !!on); }

  function updateBubble(sectionHtml) {
    var b = document.getElementById('cart-icon-bubble'); if (!b) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var wrap = doc.getElementById('shopify-section-cart-icon-bubble') || doc.getElementById('cart-icon-bubble');
    if (wrap) b.innerHTML = wrap.innerHTML;
  }

  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.getElementById('CartDrawer');
      var cur = document.getElementById('CartDrawer');
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; animateBar(); }
      var d = drawer();
      if (d) d.classList.toggle('is-empty', /is-empty/.test((doc.querySelector('cart-drawer') || {}).className || ''));
    }
    if (sections['cart-icon-bubble']) updateBubble(sections['cart-icon-bubble']);
  }

  /* single fetch + single DOM render */
  function render() {
    return fetch('?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); })
      .then(function (s) { applySections(s); }).catch(function () {});
  }
  function refreshBubble() {
    fetch('?sections=cart-icon-bubble').then(function (r) { return r.json(); })
      .then(function (s) { if (s && s['cart-icon-bubble']) updateBubble(s['cart-icon-bubble']); }).catch(function () {});
  }

  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-empty');
    d.classList.add('is-open');
    lockScroll(true);
    animateBar();                                   // animate the bar as the drawer slides in
    /* ALWAYS re-render on open: landing add-to-carts open the drawer by clicking the
       bubble, and without this the drawer shows the PREVIOUS cart state whenever the
       gift/freebie pipeline had nothing to change (e.g. second add in the same pageview) */
    busy(true);
    manageAll(function () { render().then(function () { busy(false); }); });
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open', 'active', 'animate');
    lockScroll(false);
  }

  /* mutation -> ensure gift -> exactly ONE render */
  function mutate(url, body) {
    busy(true);
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { busy(false); return; }             // error (e.g. sold out)
        manageAll(function () { render().then(function () { busy(false); }); });
      })
      .catch(function () { render().then(function () { busy(false); }); });
  }

  function change(line, quantity) { mutate('/cart/change.js', { line: line, quantity: quantity }); }
  function addVariant(variantId) { mutate('/cart/add.js', { id: variantId, quantity: 1 }); }
  /* set the TOTAL quantity of a variant across ALL its cart lines: BXGY (3+1)
     splits one variant into a paid line + a $0 line — trashing or stepping only
     one of them strands the other. IMPORTANT: every mutation can REGENERATE the
     remaining lines' keys (discount reallocation), so keys must be re-fetched
     fresh before each step instead of pre-collected. */
  function setVariantTotal(variantId, qty, done) {
    var guard = 0;
    function changeKey(key, q) {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify({ id: key, quantity: q }) });
    }
    function step() {
      if (++guard > 6) { done(); return; }
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var lines = c.items.filter(function (i) { return String(i.id) === String(variantId); });
        if (!lines.length) { done(); return; }
        if (lines.length > 1) {
          // zero the LAST duplicate line with a fresh key, then re-evaluate
          changeKey(lines[lines.length - 1].key, 0).then(step).catch(done);
          return;
        }
        // single line left: set it to the target (0 removes it)
        changeKey(lines[0].key, qty).then(function () { done(); }).catch(done);
      }).catch(function () { done(); });
    }
    step();
  }
  function setVariantQty(variantId, qty) {
    busy(true);
    setVariantTotal(variantId, qty, function () { manageAll(function () { render().then(function () { busy(false); }); }); });
  }
  /* keep the holster's BXGY freebie in sync: whenever the PAID units cross the 3+1
     threshold, bump the TOTAL so Shopify prices the extra unit at $0 (and drop it
     again when paid units fall below 3); done(changed) */
  function countHolster(c) {
    var total = 0, free = 0;
    c.items.forEach(function (i) {
      if (i.id === HOLSTER_VARIANT) { total += i.quantity; if (i.final_line_price === 0 && i.original_line_price > 0) free += i.quantity; }
    });
    return { total: total, free: free, paid: total - free };
  }
  function manageFreeHolster(done) {
    if (manageFreeHolster.__busy || manageFreeHolster.__disabled) { done && done(false); return; }
    manageFreeHolster.__busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var n = countHolster(c);
      var want = holsterTotalFor(n.paid);
      function fin(ch) { manageFreeHolster.__busy = false; done && done(ch); }
      if (n.total > 0 && n.total !== want) {
        if (want > n.total) {
          /* bumping UP relies on the BXGY discount pricing the extra unit at $0 — verify it
             did, and if not (discount missing/off) REVERT and never retry: without this
             guard every drawer interaction would add one more PAID unit. */
          setVariantTotal(HOLSTER_VARIANT, want, function () {
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c2) {
              if (countHolster(c2).free > 0) { fin(true); }
              else { manageFreeHolster.__disabled = true; setVariantTotal(HOLSTER_VARIANT, n.paid, function () { fin(true); }); }
            }).catch(function () { fin(true); });
          });
        } else {
          setVariantTotal(HOLSTER_VARIANT, want, function () { fin(true); });
        }
      }
      else fin(false);
    }).catch(function () { manageFreeHolster.__busy = false; done && done(false); });
  }
  function manageAll(done) {
    manageFreeHolster(function (ch1) { manageGift(function (ch2) { done && done(ch1 || ch2); }); });
  }
  /* swap a line's variant: remove old line, add the chosen variant with the same qty
     (the Cart API can't switch a line's variant in place), then ensure gift + one render */
  function changeVariant(line, newId, qty) {
    busy(true);
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify({ line: line, quantity: 0 }) })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify({ id: newId, quantity: qty || 1 }) }); })
      .then(function (r) { return r.json(); })
      .then(function (res) { if (res && res.status) { render().then(function () { busy(false); }); return; } manageAll(function () { render().then(function () { busy(false); }); }); })
      .catch(function () { render().then(function () { busy(false); }); });
  }

  /* any add-to-cart form (PDP main form, home product cards, survival packs) ->
     add, ensure gift, one render, then open the drawer instead of navigating to /cart */
  function wireForm() {
    document.querySelectorAll('[data-fp-pdp-form], [data-fp-add-form]').forEach(function (form) {
      if (!drawer() || form.__fpCart) return;
      form.__fpCart = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.fp-atc');
        if (btn) btn.setAttribute('aria-busy', 'true');
        var fd = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/javascript' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (btn) btn.removeAttribute('aria-busy');
            if (res && res.status) return;
            manageAll(function () { render().then(function () { openDrawer(); }); });
          }).catch(function () { form.submit(); });
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#cart-icon-bubble') || e.target.closest('.header__icon--cart')) {
      if (drawer()) { e.preventDefault(); e.stopPropagation(); openDrawer(); }
      return;
    }
    if (e.target.closest('[data-fpc-close]') || e.target.id === 'CartDrawer-Overlay') { closeDrawer(); return; }
    var vqty = e.target.closest('[data-fpc-vqty]');
    if (vqty) {
      var vid = vqty.getAttribute('data-variant');
      var vcur = parseInt(vqty.getAttribute('data-vqty'), 10) || 1;   // PAID units (freebies excluded)
      var vdir = vqty.getAttribute('data-fpc-vqty') === 'inc' ? 1 : -1;
      var np = Math.max(0, vcur + vdir);
      var vtarget = String(vid) === String(HOLSTER_VARIANT) ? holsterTotalFor(np) : np;
      setVariantQty(vid, vtarget);
      return;
    }
    var rmv = e.target.closest('[data-fpc-remove-variant]');
    if (rmv) { setVariantQty(rmv.getAttribute('data-fpc-remove-variant'), 0); return; }
    var qty = e.target.closest('[data-fpc-qty]');
    if (qty) {
      var line = parseInt(qty.getAttribute('data-line'), 10);
      var row = qty.closest('.fpc-item');
      var n = row ? parseInt(row.querySelector('.fpc-qty__n').textContent, 10) : 1;
      var dir = qty.getAttribute('data-fpc-qty') === 'inc' ? 1 : -1;
      change(line, Math.max(0, n + dir));
      return;
    }
    var rm = e.target.closest('[data-fpc-remove]');
    if (rm) { change(parseInt(rm.getAttribute('data-fpc-remove'), 10), 0); return; }
    var addBtn = e.target.closest('[data-fpc-add]');
    if (addBtn) { addVariant(addBtn.getAttribute('data-fpc-add')); return; }
    /* FBT bundle picker (like Monster): open modal, pick variant, confirm */
    if (e.target.closest('[data-fpc-add-open]')) { var mo = document.querySelector('[data-fpc-fbtmodal]'); if (mo) mo.classList.add('is-open'); return; }
    if (e.target.closest('[data-fpc-fbt-close]')) { var mc = document.querySelector('[data-fpc-fbtmodal]'); if (mc) mc.classList.remove('is-open'); return; }
    if (e.target.closest('[data-fpc-fbt-confirm]')) {
      var msel = document.querySelector('[data-fpc-fbt-sel]');
      var mm = document.querySelector('[data-fpc-fbtmodal]'); if (mm) mm.classList.remove('is-open');
      if (msel && msel.value) addVariant(msel.value);
      return;
    }
    var couponClear = e.target.closest('[data-fpc-coupon-clear]');
    if (couponClear) {
      var cbox = couponClear.closest('.fpc-coupon__box');
      if (cbox) { cbox.innerHTML = '<input type="text" class="fpc-coupon__input" placeholder="Enter Coupon Code" data-fpc-coupon-input>'; var ci = cbox.querySelector('input'); if (ci) ci.focus(); }
      return;
    }
    var coupon = e.target.closest('[data-fpc-coupon-apply]');
    if (coupon) {
      var input = document.querySelector('[data-fpc-coupon-input]');
      var code = input && input.value.trim();
      if (code) {
        busy(true);
        /* apply the discount without a full page reload (Monster-style): hit /discount to
           set it on the cart session, then re-render the drawer section */
        fetch('/discount/' + encodeURIComponent(code), { headers: { Accept: 'text/html' } })
          .then(function () { manageAll(function () { render().then(function () { busy(false); }); }); })
          .catch(function () { render().then(function () { busy(false); }); });
      }
      return;
    }
  });

  /* functional variant dropdown (like Monster): swap the line's variant on change */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-fpc-variant]');
    if (!sel) return;
    var line = parseInt(sel.getAttribute('data-line'), 10);
    var qty = parseInt(sel.getAttribute('data-qty'), 10) || 1;
    if (sel.value) changeVariant(line, sel.value, qty);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* minimal <cart-drawer> custom element: Dawn's cart-drawer.js no longer loads (it fought
     this drawer), but Dawn's product-form.js (bundle page, quick-adds) still calls
     this.cart.getSectionsToRender()/setActiveElement()/renderContents() on the element —
     provide that API and route it to the fpc pipeline. */
  if (window.customElements && !customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      open() { openDrawer(); }
      close() { closeDrawer(); }
      getSectionsToRender() { return []; }
      setActiveElement() {}
      renderContents() { busy(true); manageAll(function () { render().then(function () { busy(false); openDrawer(); }); }); }
    });
  }

  function init() { wireForm(); refreshBubble(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', wireForm);
})();
